<template>
    <div class="nx-list-page">
      <avue-crud
      ref="crud"
      v-model="form"
        :option="option"
        :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
        @row-del="rowDel"
        @search-change="searchChange"
        @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
        @current-change="currentChange"
        @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
        >
        <template slot="name" slot-scope="scope" >
          <el-tag type="success">{{ scope.row.name }}</el-tag>
        </template>
          <template slot="menuLeft">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
          plain
          :disabled="selectionList.length == 0"
              @click="handleDelete"
        >
          批量删除
            </el-button>
          </template>
        </avue-crud>
    </div>
  </template>
  
  <script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, removeBatch, getDictTree } from "./api";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";
  
  export default {
  mixins: [crudMixins],
    data() {
    const that = this;
      return {
      form: {},
      apiConfig: { getList, add, update, remove, getDetail, batchRemove: removeBatch },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        selection: true,
        column: [
          {
            label: "标签名称",
            prop: "name",
            search: true,
            overHidden: true,
            minWidth: 150,
            maxlength: 50,
            rules: rulesInput(1),
          },
          {
            label: "父级标签",
            prop: "parentId",
            type: "select",
            dicData: [],
            search: false,
            overHidden: true,
            width: 150,
            // 父级标签可以不选择，所以设为非必填
            rules: [
              {
                required: false,
                message: "请选择父级标签",
                trigger: "change",
              },
            ],
            formatter: (row) => {
              return row.parentName || "顶级标签";
            },
          },
          {
            label: "父级标签名称",
            prop: "parentName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            search: true,
            overHidden: true,
            width: 100,
            dicData: [
              { label: "无效", value: 0 },
              { label: "有效", value: 1 },
            ],
            value: 1,
            rules: rulesInput(2),
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            maxlength: 200,
            span: 24,
            minRows: 3,
            hide: true,
          },
          {
            label: "录入人",
            prop: "createName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "录入时间",
            prop: "createTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig("", { type: "datetimerange" }),
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: "修改人",
            prop: "updateName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "修改时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
        ],
      },
      defaultParams: {},
    };
  },
  mounted() {
    this.initParentTree();
  },
  methods: {
    // 初始化父级标签数据（只获取顶级标签）
    initParentTree() {
      // 获取所有数据，筛选出parentId为0的顶级标签
      getDictTree()
        .then((res) => {
          if (res.data && res.data.data && res.data.data.records) {
            const records = res.data.data.records;
            // 只筛选parentId为0的顶级标签
            const topLevelTags = records.filter((item) => !item.parentId || item.parentId === 0);
            const parentColumn = this.findObject(this.option.column, "parentId");
            if (parentColumn) {
              parentColumn.dicData = topLevelTags.map((item) => ({
                label: item.name,
                value: item.id,
              }));
            }
          }
        })
        .catch((err) => {
          console.error("获取父级标签失败:", err);
        });
    },
    // 查找对象
    findObject(array, prop) {
      return array.find((item) => item.prop === prop);
    },
    // 扩展beforeOpen，加载父级标签列表并处理数据
    beforeOpen(done, type) {
      // 调用父类方法处理详情获取
      const parentDone = () => {
        if (type === "add" || type === "edit") {
          // 如果是新增，设置默认的parentId为0（顶级标签）
          if (type === "add") {
            this.form.parentId = this.form.parentId || 0;
            this.form.status = this.form.status || 1;
          }
          // 加载父级标签列表（只包含顶级标签）
          this.initParentTree();
        }
        done();
      };
      
      // 调用crudMixins的beforeOpen
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = res.data.data || res.data;
          parentDone();
        });
      } else {
        parentDone();
      }
    },
    // 扩展rowSave，处理parentId
    rowSave(row, done, loading) {
      // 如果parentId为空或未选择，设置为0（顶级标签）
      if (!row.parentId && row.parentId !== 0) {
        row.parentId = 0;
        row.parentName = "0";
      }
      if (!row.status && row.status !== 0) {
        row.status = 1;
      }
      // 调用父类方法
      this.apiConfig.add(row).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
            this.$message({
          type: 'success',
          message: '操作成功'
            });
            done();
      }, () => {
            loading();
          });
      },
    // 扩展rowUpdate，处理parentId
    rowUpdate(row, index, done, loading) {
      // 如果parentId为空或未选择，设置为0（顶级标签）
      if (!row.parentId && row.parentId !== 0) {
        row.parentId = 0;
        row.parentName = "0";
      }
      // 调用父类方法
      this.apiConfig.update(row).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
            this.$message({
          type: 'success',
          message: '操作成功'
        });
        done();
      }, () => {
        loading();
        });
      },
    },
  };
  </script>

<style scoped lang="scss">
p {
  margin: 0;
}
</style>
